// src/firebase/index.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDpuxJo-3_2IE4gWIlaWxVmOZwpVdK32xc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "talli-auth.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "talli-auth",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "talli-auth.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "652842081690",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:652842081690:web:52eca9b956a0c747246e23",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-3V9V55580C"
};

console.log('Firebase configuration:', firebaseConfig);

// Initialize Firebase
let app, auth, firestore;

try {
  console.log('Initializing Firebase app...');
  app = initializeApp(firebaseConfig);
  console.log('Firebase app initialized successfully:', app);
  
  console.log('Getting Firebase auth...');
  auth = getAuth(app);
  console.log('Firebase auth obtained:', auth);
  
  console.log('Getting Firestore...');
  firestore = getFirestore(app);
  console.log('Firestore obtained successfully');
} catch (error) {
  console.error('Error initializing Firebase:', error);
  throw error;
}

export { app, auth, firestore };